import { useMutation } from "@tanstack/react-query";

import { forgotPasswordRequest } from "../requests/forgot-password-request";

export const useForgotPasswordMutation = () => {
  return useMutation({
    mutationFn: forgotPasswordRequest,
  });
};
